<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (risk) {
    <div class="detail-page-action-bar">
        @if (!permissions.readonly) {
            <button class="btn btn-cerrix" (click)="save()" data-uiid="button-save-risk">
                <i class="fas fa-save"></i>
                <span class="d-none d-lg-inline">{{ 'detail.saveRisk' | t }}</span>
            </button>
        }

        @if (risk.id > 0) {
            <span class="date-edited"> Last save: {{ risk.lastSaveDate | dateTimeFormat }} </span>
        }
    </div>
}

@if (riskLoaded) {
    <div
        class="datamanagement-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
        data-uiid="risk-detail-page"
    >
        <div
            class="risk-screens"
            [attr.name]="'Risk'"
            menuicon="fas fa-exclamation-triangle"
            menusystemsubmenu
        >
            <div
                [attr.name]="'detail.menuDetails' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
                menuItemId="Details"
            >
                <risk-detail-main
                    [risk]="risk"
                    [parentForm]="parentForm"
                    [permissions]="permissions"
                    [impactScaleData]="impactScaleData"
                    [customFieldData]="customFieldData"
                    #riskDetail
                >
                </risk-detail-main>
            </div>
            @if (risk.id > 0) {
                <div
                    [attr.name]="'detail.menuRiskResultOverview' | t"
                    menuItemId="resultOverview"
                    menuicon="fas fa-stream"
                    menusystemitem
                >
                    <risk-result-overview [risk]="risk" #riskResultOverviewComponent>
                    </risk-result-overview>
                </div>
                <div
                    class="risk-screens"
                    [attr.name]="'Links'"
                    menuicon="fas fa-link"
                    menusystemsubmenu
                >
                    <div
                        [attr.name]="'detail.menuControls' | t"
                        [attr.menuItemId]="controlsMenuItemId"
                        menuicon="fas fa-shield-alt"
                        menusystemitem
                    >
                        <risk-controls
                            [model]="risk"
                            [disabled]="!permissions.canLinkControls"
                            [permissions]="permissions"
                            #riskControlsComponent
                        >
                        </risk-controls>
                    </div>

                    <div
                        [attr.name]="'detail.menuEvents' | t"
                        [attr.menuItemId]="eventsMenuItemId"
                        menuicon="fas fa-bolt"
                        menusystemitem
                    >
                        <risk-events [model]="risk" #riskEventsComponent> </risk-events>
                    </div>

                    @if (permissions.canLinkBim || permissions.canViewMoi) {
                        <div
                            [attr.name]="'detail.menuMeasuresOfImprovement' | t"
                            menuicon="fas fa-tasks"
                            [attr.menuItemId]="moisMenuItemId"
                            menusystemitem
                        >
                            <risk-mois
                                [risk]="risk"
                                [permissions]="permissions"
                                [showAdvancedFilters]="true"
                                [activeFilters]="activeFilters"
                                #moisComponent
                            >
                            </risk-mois>
                        </div>
                    }

                    <div
                        [attr.name]="'detail.menuKeyRiskIndicators' | t"
                        menuicon="fa-solid fa-gauge-high"
                        menuItemId="kriMenuItemId"
                        menusystemitem
                    >
                        <risk-kri [model]="risk" [permissions]="permissions" #kriComponent>
                        </risk-kri>
                    </div>

                    @if (permissions.canViewAssets) {
                        <div
                            [attr.name]="'detail.menuAssets' | t"
                            [attr.menuItemId]="assetsMenuItemId"
                            menuicon="fas fa-server"
                            menusystemitem
                        >
                            <app-linked-assets
                                [linkedAssetIds]="risk.linkedAssetIds"
                                [organizationId]="risk.organizationId"
                                [disabled]="!permissions.canLinkAssets"
                                (linkedAssetIdsChange)="linkedAssetIdsChanged($event)"
                                #assetsComponent
                            >
                            </app-linked-assets>
                        </div>
                    }

                    <div
                        [attr.name]="'detail.menuDataProcessing' | t"
                        menuItemId="dataProcessing"
                        menuicon="fas fa-database"
                        menusystemitem
                    >
                        <risk-datamanagement [risk]="risk" #datamanagementComponent>
                        </risk-datamanagement>
                    </div>
                    @if (permissions.canViewTP) {
                        <div
                            menuItemId="menuItemTp"
                            [attr.name]="'detail.menuThirdParty' | t"
                            menuicon="fas fa-handshake"
                            menusystemitem
                        >
                            <risk-thirdparty #thirdpartyComponent [risk]="risk">
                            </risk-thirdparty>
                        </div>
                    }
                    <div
                        [attr.name]="'detail.menuDocuments' | t"
                        [attr.menuItemId]="documentsMenuItemId"
                        menuicon="far fa-file"
                        menusystemitem
                    >
                        @if (risk.Documents) {
                            <div>
                                <document-manager-old
                                    [(Documents)]="risk.Documents"
                                    [permissions]="permissions.documentPermissions"
                                    (DocumentsChange)="documentsChanged($event)"
                                    [DocumentTypeTargets]="targetModule"
                                ></document-manager-old>
                            </div>
                        } @else {
                            <div>
                                <div class="fancy-loader"></div>
                            </div>
                        }
                    </div>
                    <div
                        [attr.name]="'detail.menuHyperlinks' | t"
                        [attr.menuItemID]="hyperlinksMenuItemId"
                        menuicon="fas fa-external-link-alt"
                        menusystemitem
                    >
                        @if (risk.Hyperlinks) {
                            <div>
                                <hyperlink-manager
                                    [Hyperlinks]="risk.Hyperlinks"
                                    (HyperlinksChanged)="hyperlinksChanged($event)"
                                    [TargetModule]="targetModule"
                                ></hyperlink-manager>
                            </div>
                        } @else {
                            <div>
                                <div class="fancy-loader"></div>
                            </div>
                        }
                    </div>
                </div>

                <div [attr.name]="'detail.menuHistory' | t" menuicon="fas fa-history" menusystemitem menuItemId="history">
                    <app-history-overview
                        #historyOverviewComponent
                        [historyDataService]="riskDS"
                        [Id]="risk.guid"
                        [useOldHistory]="true"
                    >
                    </app-history-overview>
                </div>

                <div
                    [attr.name]="'detail.menuOptions' | t"
                    menuItemId="options"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="risk"
                        [objectName]="risk ? risk.name : 'risk'"
                        [allowDelete]="permissions.canDelete"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
